// import React from "react";
import { GetStaticProps } from "next/types";
import nextI18nextConfig from "next-i18next.config";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Page } from "types/page";
import { MediaAssets, MediaKitHero } from "@cs/screens/media-kit";

const MediaKitPage: Page = () => (
  <main>
    <MediaKitHero />
    <MediaAssets />
  </main>
)

export default MediaKitPage

export const getStaticProps: 
  GetStaticProps = async ({locale}) => ({
    props: {
      ...(await serverSideTranslations(
        locale ?? 'en',
        ["common", "footer", "nav", "media-kit"],
        nextI18nextConfig
      )),
    }
  })